export default "__VITE_ASSET__DVawyhst__"